import { render } from "./PenIcon.vue?vue&type=template&id=3a047833"
import script from "./PenIcon.vue?vue&type=script&lang=js"
export * from "./PenIcon.vue?vue&type=script&lang=js"
script.render = render

export default script